module.exports = __webpack_public_path__ + "static/media/Devoir_Vigilance.0d84e42f.pdf";